import { useState } from 'react';
import { Maps } from '@hopskipdrive/react-components';

import { preciseMarkerSvg, staticMarkerSvg } from './constants';
import { MapContainer } from './styles';

interface LocationMapViewProps {
  coordinates?: { lat: number; lng: number };
  preciseCoordinates?: { lat: number; lng: number };
}

export const LocationMapView = ({ coordinates, preciseCoordinates }: LocationMapViewProps) => {
  const [mapInstance, setMapInstance] = useState<google.maps.Map>();

  const markerPosition = preciseCoordinates || coordinates;

  const getMarkerIcon = () => {
    if (mapInstance) {
      return {
        icon: {
          url:
            'data:image/svg+xml;charset=utf-8,' +
            encodeURIComponent(preciseCoordinates ? preciseMarkerSvg : staticMarkerSvg),
          anchor: new window.google.maps.Point(21, 56),
        },
      };
    }

    return undefined;
  };

  return (
    <MapContainer>
      <Maps
        handleMapInstance={(instance) => setMapInstance(instance)}
        googleMapsApiKey={window.env?.RIDEIQ_GOOGLE_MAPS_API_KEY}
        center={markerPosition}
        zoom={19}
        height="745px"
        showLayerToggle={true}
        options={{
          tilt: 0, // Force top-down view (no 3D perspective)
          heading: 0, // North-up orientation
          cameraControlOptions: {
            position: 3,
          },

          mapTypeId: 'hybrid',
        }}
      >
        {markerPosition && <Maps.DraggableMarker position={markerPosition} {...getMarkerIcon()} draggable={false} />}
      </Maps>
    </MapContainer>
  );
};
